module.exports = __webpack_public_path__ + "img/event_carpet_expoluxe_9520_black.24c9dcd8.jpg";